import React, { Component } from "react";
import PricingHeader from "../pricingHeader/PricingHeader";
import { withTranslation } from "react-i18next";
import { ValidatorForm } from "react-material-ui-form-validator";
import ValidationRules from "../../../../common/ValidationRules";
import SortData from "../../../../utils/SortUtil";
import PricingRow from "../pricingRow/PricingRow";
import PositiveValue from "../../../../utils/PostiveValue";
import { CHARGE, DISCOUNT, NONE } from "../../../../common/Constants";

class PricingDetails extends Component {
  constructor(props) {
    super(props);
    const that = this;
    this.props.pricingData.forEach(function (item) {
      item["futureIncentives"] =
        (item.entityId &&
          that.props.futureIncentives &&
          that.props.futureIncentives[item.entityId] &&
          that.props.futureIncentives[item.entityId]["incentives"]) ||
        null;

      let totalBenefitAmount = 0;
      item["futureIncentives"] &&
        item["futureIncentives"].forEach((program) => {
          totalBenefitAmount += parseInt(program.benefitAmount);
        });
      item["totalBenefitAmount"] = totalBenefitAmount;

      item["totalCustomerSaving"] =
        ((item.vm && item.vm.customerSaving) || 0) + item.totalBenefitAmount;
      item["dealerVehiclePrice"] = that.calculateDealerVehiclePrice(
        item.adj,
        item
      );
      item["transactionPrice"] = that.calculateTransactionPrice(item);
    });
    const pricingData = this.concatSigns();
    this.state = {
      pricingData: pricingData,
      sortDirection: null,
      sortKey: "vehicleInfo",
      individualEditIndex: -1,
      individualEditEnabled: false,
    };
    this.modifiedPricingData = [];
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.makeCopyOfPricingData();
    this.performOnLoadTasks();
    ValidationRules();
    Array.isArray(this.props.catalogIds) &&
      this.props.catalogIds.length > 1 &&
      this.sortPricingData("year");
  }

  handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }
    this.updateVehiclePrice();
  }

  calculateTransactionPrice(pricing) {
    let fees = 0;
    const feesMap = new Map();
    if (!!this.props.feesData) {
      this.props.feesData.forEach(function (val) {
        feesMap.set(val.entity, val);
      });
      const feeSet = feesMap.get(pricing.entityId);
      if (feeSet) {
        this.props.fees.forEach((fee) => {
          fees = fees + feeSet[fee.key];
        });
      }

      const finalAmt = Number.parseFloat(pricing.dealerVehiclePrice) + fees;
      return Number.parseFloat(finalAmt).toFixed(2);
    }
  }

  makeCopyOfPricingData = () => {
    //In Discount mode if changes are cancelled we need this previous copy to replace the values
    const pricingData = JSON.parse(JSON.stringify(this.state.pricingData));
    this.pricingDataCopy = pricingData;
  };

  performOnLoadTasks() {
    // Creating pricing Map key as vehicleInfo, Value is pricing record with current index
    // This is required to keep original values
    this.vehicleInfoWithIndex = new Map();
    const that = this;
    const pricingDataCopy = JSON.parse(JSON.stringify(this.state.pricingData)); //Required to store in VehicleInfoWithIndexMap to store original values
    pricingDataCopy.forEach(function (pricing, index) {
      pricing.index = index;
      pricing.adjType = null;
      that.vehicleInfoWithIndex.set(pricing.entityId, pricing);
    });
  }

  updateVehicleInfoWithIndex(fromSort) {
    if (fromSort) {
      const that = this;
      this.state.pricingData.forEach(function (pricing, index) {
        that.vehicleInfoWithIndex.get(pricing.entityId).index = index;
      });
    }
  }

  sortPricingData(sortByCol, fromSubmit = false) {
    // If dealer has just edited prices, re-sort the way things were previously sorted
    let sortDir;
    if (fromSubmit) {
      sortDir = this.state.sortDirection;
    } else {
      // Default to descending if first click of this arrow
      sortDir = "DSC";
      if (sortByCol === this.state.sortKey) {
        sortDir = this.state.sortDirection === "ASC" ? "DSC" : "ASC";
      }
    }

    const that = this;
    SortData(
      sortByCol,
      sortDir,
      "alphanumeric",
      this.state.pricingData,
      function (sortedData) {
        that.setState(
          {
            pricingData: sortedData,
            sortDirection: sortDir,
            sortKey: sortByCol,
          },
          () => {
            that.makeCopyOfPricingData();
            that.updateVehicleInfoWithIndex(true);
          }
        );
      }
    );
  }

  editRecords() {
    this.updateEditFlag(true);
  }

  concatSigns() {
    const pricingDataCopy = JSON.parse(JSON.stringify(this.props.pricingData));

    pricingDataCopy.forEach((dataRow) => {
      dataRow.adj = dataRow.adj.toString();
    });
    return pricingDataCopy;
  }

  cancelChanges() {
    this.updateEditFlag(false);
    this.setState({
      pricingData: this.pricingDataCopy,
      individualEditIndex: -1,
      individualEditEnabled: false,
    });
  }

  updateEditFlag(value) {
    this.props.updateEditFlag(value);
  }

  updateIndividualEditFlag = (value) => {
    this.setState({ individualEditEnabled: value });
  };

  updateDiscountPrice(value, item) {
    const copy = JSON.parse(JSON.stringify(this.state.pricingData));
    const index = this.vehicleInfoWithIndex.get(item.entityId).index;
    const currentData = copy[index];
    currentData.adj = value;
    if (value !== "") {
      currentData.adj = this.getAdjFloat(currentData);
    }
    copy[index] = currentData;
    this.setState({ pricingData: copy });
  }

  updateAdjustment(value, item) {
    const copy = JSON.parse(JSON.stringify(this.state.pricingData));
    const index = this.vehicleInfoWithIndex.get(item.entityId).index;
    const currentData = copy[index];
    currentData.adjType = value;
    currentData.adj = this.getAdjFloat(currentData);
    copy[index] = currentData;
    this.setState({ pricingData: copy });
    this.vehicleInfoWithIndex.get(item.entityId).adjType = value;
  }

  resetVehiclesRow = (event, item) => {
    const copy = JSON.parse(JSON.stringify(this.state.pricingData));
    const index = this.vehicleInfoWithIndex.get(item.entityId).index;
    const currentData = copy[index];
    currentData.adjType = DISCOUNT;
    currentData.adj = this.getRecommendedAdjFloat(
      currentData,
      item.recommendedAdj
    );
    currentData.dealerVehiclePrice = this.calculateDealerVehiclePrice(
      item.recommendedAdj,
      currentData
    );
    copy[index] = currentData;

    this.setState(
      {
        pricingData: copy,
        individualEditIndex: -1,
      },
      () => {
        this.updateVehiclePrice();
      }
    );
    this.vehicleInfoWithIndex.get(item.entityId).adjType = currentData.adjType;
    this.vehicleInfoWithIndex.get(item.entityId).adj = currentData.adj;
  };

  updateIndividualEditIndex = (index) => {
    this.setState({
      individualEditIndex: index,
    });
  };

  getAdjFloat = (pricing) => {
    let adj = parseFloat(pricing.adj);

    //if selected Adj type is CHARGE and amount is negative, make it positive
    if (pricing.adjType === CHARGE) {
      adj = Math.abs(adj);
    }
    //if selected Adj type is DISCOUNT and amount is positive, make it negative
    else if (pricing.adjType === DISCOUNT) {
      adj = Math.abs(adj) * -1;
    }

    return adj;
  };

  getRecommendedAdjFloat = (pricing, recommendedAdj) => {
    let adj = parseFloat(recommendedAdj);

    //if selected Adj type is CHARGE and amount is negative, make it positive
    if (pricing.adjType === CHARGE && adj < 0) {
      adj = -1 * adj;
    }
    //if selected Adj type is DISCOUNT and amount is positive, make it negative
    else if (pricing.adjType === DISCOUNT && adj > 0) {
      adj = -1 * adj;
    }
    return adj;
  };

  updateVehiclePrice() {
    this.updateEditFlag(false);
    const that = this;
    this.state.pricingData.forEach(function (pricing) {
      const initialRecord = that.vehicleInfoWithIndex.get(pricing.entityId);
      const adjFloat = that.getAdjFloat(pricing);
      if (parseFloat(initialRecord.adj) !== adjFloat) {
        const modifiedPricingDataIndex = that.findObjectIndexFromArray(
          that.modifiedPricingData,
          pricing
        );
        if (modifiedPricingDataIndex === -1) {
          pricing["dealerVehiclePrice"] = that.calculateDealerVehiclePrice(
            adjFloat,
            pricing
          );
          pricing["transactionPrice"] = that.calculateTransactionPrice(pricing);
          that.modifiedPricingData.push(pricing);
        } else if (
          modifiedPricingDataIndex !== -1 &&
          that.modifiedPricingData[modifiedPricingDataIndex].adj !== pricing.adj
        ) {
          pricing["dealerVehiclePrice"] = that.calculateDealerVehiclePrice(
            adjFloat,
            pricing
          );
          pricing["transactionPrice"] = that.calculateTransactionPrice(pricing);
          pricing["adjType"] = that.getAdjType(pricing.adj);
          that.modifiedPricingData[
            modifiedPricingDataIndex
          ].dealerVehiclePrice = pricing.dealerVehiclePrice;
          that.modifiedPricingData[modifiedPricingDataIndex].adj = pricing.adj;
          that.modifiedPricingData[modifiedPricingDataIndex].transactionPrice =
            pricing.transactionPrice;
        }
      }
    });

    this.setState({ pricingData: this.state.pricingData }, () => {
      this.makeCopyOfPricingData();
    });

    this.props.updatePricingData(this.state.pricingData);
    if (
      this.state.sortKey === "dealerVehiclePrice" ||
      this.state.sortKey === "transactionPrice"
    ) {
      this.sortPricingData(this.state.sortKey, true);
    }

    this.setState({ individualEditIndex: -1, individualEditEnabled: false });
  }

  // function to find index of object from array of objects (only for wersInfo)
  findObjectIndexFromArray = (pricingData, item) => {
    if (pricingData) {
      return pricingData.findIndex(
        (pricing) => pricing["entityId"] === item.entityId
      );
    } else {
      return -1;
    }
  };

  getAdjType = (adj) => {
    let valueDropDown = NONE;
    if (Math.sign(adj) === 1) {
      valueDropDown = CHARGE;
    } else if (Math.sign(adj) === -1) {
      valueDropDown = DISCOUNT;
    }
    return valueDropDown;
  };

  calculateDealerVehiclePrice(dealerDiscount, pricing) {
    const rrp = pricing.rrp;
    const customerSaving = pricing.totalCustomerSaving;
    const dealerVehiclePrice =
      pricing.adjType === DISCOUNT
        ? rrp - customerSaving - PositiveValue(dealerDiscount)
        : rrp - customerSaving + PositiveValue(dealerDiscount);

    return Number.parseFloat(dealerVehiclePrice).toFixed(2);
  }

  render() {
    return (
      this.state.pricingData.length > 0 && (
        <ValidatorForm onSubmit={this.handleSubmit}>
          <div>
            <PricingHeader
              onSort={(key) => this.sortPricingData(key)}
              catalogIds={this.props.catalogIds}
              editRecords={(e) => this.editRecords(e)}
              cancelChanges={() => this.cancelChanges()}
              isDealer={this.props.isDealer}
              sortDirection={this.state.sortDirection}
              sortKey={this.state.sortKey}
              isEditEnabled={
                this.props.isEditEnabled || this.state.individualEditEnabled
              }
              isDisabled={true}
              user={this.props.user}
            />
            {this.state.pricingData.map((item, index) => {
              return (
                <PricingRow
                  {...this.props}
                  isEditEnabled={this.props.isEditEnabled}
                  index={index}
                  key={index}
                  dataRow={item}
                  resetVehiclesRow={this.resetVehiclesRow}
                  currencySymbol={this.props.currencySymbol}
                  onChange={(e) => this.props.onChange(e, item)}
                  isDealer={this.props.isDealer}
                  isDisabled={true}
                  updateDiscountPrice={(value) =>
                    this.updateDiscountPrice(value, item)
                  }
                  updateAdjustment={(e) => this.updateAdjustment(e, item)}
                  individualEditIndex={this.state.individualEditIndex}
                  updateIndividualEditIndex={this.updateIndividualEditIndex}
                  updateIndividualEditFlag={this.updateIndividualEditFlag}
                  editChecked={this.props.editChecked}
                  rowEditSaved={this.props.rowEditSaved}
                  rowEditedCheckbox={this.props.rowEditedCheckbox}
                  newlyReleased={this.props.newlyReleased}
                />
              );
            })}
          </div>
        </ValidatorForm>
      )
    );
  }
}

export default withTranslation("emp")(PricingDetails);
